module.exports = {
  ACTION_TAKEN: {
    AUTHORIZED: 'AUTHORIZED',
    NOT_AUTHORIZED: 'NOT_AUTHORIZED'
  }
};
